/**
 * Footer — wordmark + links + per-album credit line.
 */

import { Fragment } from 'react';
import { Reveal } from './primitives/Reveal';
import { footerCopy } from '@/copy/footer';
import type { AvailableAlbumModule } from '@/types/album';

interface FooterProps {
  album: AvailableAlbumModule;
}

export function Footer({ album }: FooterProps): JSX.Element {
  return (
    <Reveal as="footer" className="nl-footer" role="contentinfo">
      <div className="nl-footer-mark">NYX</div>
      <div className="nl-footer-fine">
        <div>
          Análisis original. {album.library.album} · {album.library.artist} ·{' '}
          {album.library.year}.
        </div>
        <div>{footerCopy.lyricsDisclaimer}</div>
      </div>
      <div className="nl-footer-links">
        {footerCopy.links.map((l, i) => (
          <Fragment key={l.href}>
            {i > 0 && (
              <span className="nl-footer-separator" aria-hidden="true">
                ·
              </span>
            )}
            <a href={l.href} className="nl-footer-link">
              {l.label}
            </a>
          </Fragment>
        ))}
        <span className="nl-footer-separator" aria-hidden="true">
          ·
        </span>
        <span className="nl-footer-link" aria-label={`Año ${footerCopy.copyrightYear}`}>
          © {footerCopy.copyrightYear}
        </span>
      </div>
    </Reveal>
  );
}
